import React from "react";
import { Form } from "react-bootstrap";

function StudentRegistration_stap_3({ register, errors }) {
  return (
    <>
      <h5 className="step-heading">C. Address & Contact</h5>
      <div className="form_holder">
        <div className="row">
          <div className="col-md-12">
            <div className="col-md-6">
              <Form.Group className="mb-3">
                <Form.Label>Passport Number</Form.Label>
                <Form.Control
                  {...register("passport_number", {
                    required: "Passport number is required",
                  })}
                  placeholder="Enter Passport Number"
                />
                {errors.passport_number && (
                  <Form.Text className="text-danger">
                    {errors.passport_number.message}
                  </Form.Text>
                )}
              </Form.Group>
            </div>
            <div className="col-md-6">
              <Form.Group className="mb-3">
                <Form.Label>Passport Issuing Country</Form.Label>
                <Form.Control
                  {...register("passport_issue_country", {
                    required: "Passport Issuing Country is required",
                  })}
                  placeholder="Enter Issuing Country"
                />
                {errors.passport_issue_country && (
                  <Form.Text className="text-danger">Required</Form.Text>
                )}
              </Form.Group>
            </div>
            <div className="col-md-6">
              <Form.Group className="mb-3">
                <Form.Label>Passport Expiry Date</Form.Label>
                <Form.Control
                  type="date"
                  {...register("passport_expiry_date", {
                    required: "Expiry date is required",
                  })}
                />
                {errors.passport_expiry_date && (
                  <Form.Text className="text-danger">
                    {errors.passport_expiry_date.message}
                  </Form.Text>
                )}
              </Form.Group>
            </div>
            <div className="col-md-12">
              <Form.Group className="mb-3">
                <Form.Label>Address (as per passport)</Form.Label>
                <Form.Control
                  as="textarea"
                  rows={3}
                  {...register("passport_address", {
                    required: "Address is required",
                  })}
                  placeholder="Enter Address"
                />
                {errors.passport_address && (
                  <Form.Text className="text-danger">
                    {errors.passport_address.message}
                  </Form.Text>
                )}
              </Form.Group>
            </div>
            <div className="col-md-12">
              <Form.Group className="mb-3">
                <Form.Label>Current Address (if different)</Form.Label>
                <Form.Control
                  as="textarea"
                  rows={3}
                  {...register("passport_current_address")}
                  placeholder="Enter Current Address (optional)"
                />
              </Form.Group>
            </div>
            <div className="col-md-6">
              <Form.Group className="mb-3">
                <Form.Label>Mobile Phone Number</Form.Label>
                <Form.Control
                  {...register("passport_contact_no", {
                    required: "Mobile is required",
                    pattern: {
                      value: /^[0-9]{10}$/,
                      message: "Please enter a valid 10-digit phone number",
                    },
                  })}
                  placeholder="Enter Mobile"
                />
                {errors.passport_contact_no && (
                  <Form.Text className="text-danger">
                    {errors.passport_contact_no.message}
                  </Form.Text>
                )}
              </Form.Group>
            </div>
            <div className="col-md-12">
              <h5 className="step_sub_heading">
                Emergency Contact (Parent / Legal Guardian)
              </h5>
            </div>
            <div className="col-md-6">
              <Form.Group className="mb-3">
                <Form.Label>Guardian Name</Form.Label>
                <Form.Control
                  {...register("guardian_name", {
                    required: "Guardian name is required",
                  })}
                  placeholder="Enter Name"
                />
                {errors.guardian_name && (
                  <Form.Text className="text-danger">
                    {errors.guardian_name.message}
                  </Form.Text>
                )}
              </Form.Group>
            </div>
            <div className="col-md-6">
              <Form.Group className="mb-3">
                <Form.Label>Relationship</Form.Label>
                <Form.Control
                  {...register("relation", {
                    required: "Relationship is required",
                  })}
                  placeholder="e.g. Father"
                />
                {errors.relation && (
                  <Form.Text className="text-danger">
                    {errors.relation.message}
                  </Form.Text>
                )}
              </Form.Group>
            </div>
            <div className="col-md-6">
              <Form.Group className="mb-3">
                <Form.Label>Guardian Phone</Form.Label>
                <Form.Control
                  {...register("guardian_phone", {
                    required: "Phone is required",
                    pattern: {
                      value: /^[0-9]{10}$/,
                      message: "Please enter a valid 10-digit phone number",
                    },
                  })}
                  placeholder="Enter Phone"
                />
                {errors.guardian_phone && (
                  <Form.Text className="text-danger">
                    {errors.guardian_phone.message}
                  </Form.Text>
                )}
              </Form.Group>
            </div>
            <div className="col-md-6">
              <Form.Group className="mb-3">
                <Form.Label>Guardian Email</Form.Label>
                <Form.Control
                  type="email"
                  {...register("guardian_email", {
                    required: "Email is required",
                    pattern: {
                      value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                      message: "Please enter a valid email address",
                    },
                  })}
                  placeholder="Enter Email"
                />
                {errors.guardian_email && (
                  <Form.Text className="text-danger">
                    {errors.guardian_email.message}
                  </Form.Text>
                )}
              </Form.Group>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default StudentRegistration_stap_3;
